import Vue from "vue";
import router from "../router";
import { destroyFullStory } from "@/common/fullstory";
export const getHeader = function () {
  const headers = {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  };
  var tokenData = Vue.ls.get("login_data");
  if (tokenData) {
    tokenData = JSON.parse(tokenData);
    headers["Authorization"] = "Bearer " + tokenData.token;
  }
  return headers;
};

export const handleGoResponse = function (response, exportname, cb) {
  response
    .then(function (res) {
      cb(null, res.data);
    })
    .catch(function (err) {
      handleError(err, cb);
    });
};

function handleError(err, cb) {
  if (err.response && err.response.status === 401) {
    // Vue.ls.remove('login_data')
    // router.push({ name: "Login" });
  } else if (err.response && err.response.status === 403) {
    //router.push({ name: 'PageNotFound', params: ['/permission-denied'] })
  } else if (err.response && err.response.status === 404) {
    router.push({ name: "PageNotFound", params: ["/page-not-found"] });
  } else if (err.response && err.response.status === 503) {
    router.push({ name: "UnderMaintenance", params: ["/under-maintenance"] });
  } else if (err.response) {
    cb(new Error(err.response.data.message), err.response.data);
  }
}

export const handleResponse = function (response, exportname, cb) {
  response
    .then(function (res) {
      if (exportname) {
        var a = document.createElement("a");
        var blob = null;
        if (exportname.indexOf(".csv") !== -1) {
          blob = new Blob(["\uFEFF", res.data], {
            type: "text/csv;charset=utf-8;",
          });
        } else {
          blob = new Blob([res.data], {
            type: "application/octet-stream",
          });
        }
        a.href = window.URL.createObjectURL(blob);
        a.download = exportname;
        var event = new MouseEvent("click");
        a.dispatchEvent(event);
        cb(null, res.data);
      } else if (res.data.status && res.data.status === "success") {
        cb(null, res.data);
      } else if (res.status && res.status === 201) {
        cb(null, res.data);
      } else {
        cb(new Error(res.data.message), res.data);
      }
    })
    .catch(function (err) {
      if (err.response && err.response.status === 401) {
        destroyFullStory();
        Vue.ls.remove("login_data");
        router.push({ name: "Login" });
      } else if (err.response && err.response.status === 403) {
        router.push({ name: "PageNotFound", params: ["/permission-denied"] });
      } else if (err.response && err.response.status === 404) {
        router.push({ name: "PageNotFound", params: ["/page-not-found"] });
      } else if (err.response && err.response.status === 503) {
        router.push({
          name: "UnderMaintenance",
          params: ["/under-maintenance"],
        });
      } else if (err.response) {
        cb(new Error(err.response.data.message), err.response.data);
      }
    });
};

export const getClientType = function () {
  return "mailercloud";
};

export const getApiUrl = function (serverId = null) {
  serverId = serverId || getServerId();
  var configVar = "VUE_APP_API_BASE_URL_" + serverId;
  if (serverId && process.env[configVar]) {
    return process.env[configVar];
  }
  return process.env.VUE_APP_API_BASE_URL;
};

export const getGoApiUrl = function (serverId = null) {
  serverId = serverId || getServerId();
  var configVar = "VUE_APP_GO_API_BASE_URL_" + serverId;
  if (serverId && process.env[configVar]) {
    return process.env[configVar];
  }
  return process.env.VUE_APP_GO_API_BASE_URL;
};

export const getFormShareUrl = function (serverId = null) {
  serverId = serverId || getServerId();
  var configVar = "VUE_APP_FORM_SHARE_URL_" + serverId;
  if (serverId && process.env[configVar]) {
    return process.env[configVar];
  }
  return process.env.VUE_APP_FORM_SHARE_URL;
};

export const getFormScriptUrl = function (serverId = null) {
  serverId = serverId || getServerId();
  var configVar = "VUE_APP_FORM_SCRIPT_URL_" + serverId;
  if (serverId && process.env[configVar]) {
    return process.env[configVar];
  }
  return process.env.VUE_APP_FORM_SCRIPT_URL;
};

export const getApiLinkCheckUrl = function () {
  return process.env.VUE_APP_API_LINK_CHECK_URL;
};

export const getApiBaseUrl = function (serverId = null) {
  return getApiUrl(serverId).replace("/v2", "");
};

export const getServerId = function () {
  var serverId = null;
  var loginData = Vue.ls.get("login_data");
  if (loginData) {
    loginData = JSON.parse(loginData);
    serverId = loginData.server_id;
  }
  return serverId;
};
